import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#001F3F] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex flex-col items-start space-y-2">
              <img 
                src="https://customer-assets.emergentagent.com/job_modernshop-7/artifacts/5an6hmw2_onemore%20beyaz%20logo.png" 
                alt="One More International" 
                className="h-12 w-auto object-contain"
              />
              <span className="text-white text-xs font-semibold">
                Resmi Bağımsız Distribütör
              </span>
            </div>
            <p className="text-sm text-gray-300">
              Kaliteli ve eşsiz ürünlerle dünyaya hizmet ediyoruz.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Hızlı Linkler</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-gray-300 hover:text-white transition-colors">
                  Anasayfa
                </Link>
              </li>
              <li>
                <Link to="/onemoreurunler" className="text-sm text-gray-300 hover:text-white transition-colors">
                  One More Ürünler
                </Link>
              </li>
              <li>
                <Link to="/sertifikalar" className="text-sm text-gray-300 hover:text-white transition-colors">
                  Sertifikalar
                </Link>
              </li>
              <li>
                <Link to="/hakkimizda" className="text-sm text-gray-300 hover:text-white transition-colors">
                  Hakkımızda
                </Link>
              </li>
              <li>
                <Link to="/iletisim" className="text-sm text-gray-300 hover:text-white transition-colors">
                  İletişim
                </Link>
              </li>
              <li>
                <Link to="/sss" className="text-sm text-gray-300 hover:text-white transition-colors">
                  Sık Sorulan Sorular
                </Link>
              </li>
              <li>
                <a href="https://om.run/!adxpokr" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-300 hover:text-white transition-colors">
                  Kayıt Ol
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-semibold mb-4">İletişim</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <Phone size={18} className="mt-1 flex-shrink-0" />
                <span className="text-sm text-gray-300">+90 535 065 70 41</span>
              </li>
              <li className="flex items-start space-x-3">
                <Mail size={18} className="mt-1 flex-shrink-0" />
                <span className="text-sm text-gray-300">bantlayenilen@gmail.com</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-12 pt-8 text-center">
          <p className="text-sm text-gray-300">
            &copy; {new Date().getFullYear()} Tüm hakları saklıdır.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;